module.exports = __webpack_public_path__ + "img/goolePlay.8bef257.svg";